import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogeComponent } from '../dialoge/dialoge.component';
import { firstValueFrom } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DocType, MediaConstant } from 'src/app/job-seeker/Models/constant';
import { JobSeekerService } from 'src/app/job-seeker/Services/job-seeker.service';
import { StorageService } from '../../Services/storage.service';
import { TitleService } from '../../Services/title.service';

@Component({
  selector: 'app-upload-document-list',
  templateUrl: './upload-document-list.component.html',
  styleUrls: ['./upload-document-list.component.css']
})
export class UploadDocumentListComponent {
  @Input() data: any;
  @Output() deleteItem = new EventEmitter<any>();
  @Output() IsDeleteAction = new EventEmitter<boolean>();
  @Input() isDeleteAction: boolean=true;
  @Input() isDownload: boolean=true;
  docs: any;
  docId: any;
  Type: any;
  mediaConstant: any;
  isLogin=false;
  constructor(
    private titleService: TitleService,
    private Diloge: MatDialog,
    private jobSeekerService: JobSeekerService,
     private storageService:StorageService
  ) {
    this.isLogin = this.storageService.isLoggedIn();
    this.Type = DocType.Other;
    this.mediaConstant = MediaConstant;

  }
  async getMediaOnLoad(ImageName: any, Type: any, i: any) {
    const mediaModel = {
      ImageName: ImageName,
      Type: Type
    };
    try {
      const res: any = await firstValueFrom(this.jobSeekerService.getMedia(mediaModel));
      if (res.succeeded) {
        this.data[i].file = res.data;
      }
    } catch (error) {

    }
  }

  async downloadDocument(item: any, i: any): Promise<void> {
    if (!item.file) {
      try {
        await this.getMediaOnLoad(item.sysName, this.mediaConstant.Image, i);
      } catch (error) {
        console.error('Failed to load media:', error);
        return;
      }
    }

    if (!item.file) {
      console.error('Invalid file or document name.');
      return;
    }

    const link = document.createElement('a');
    link.href = item.file;
    link.download = item.documentName;

    if (!link.href.startsWith('data:') && !link.href.startsWith(window.location.origin)) {
      console.warn('Cross-origin download detected, redirecting to the file URL.');
      window.open(item.file, '_blank');
      return;
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  deletePopUp(index:number,doc:any) {
    if (doc.tDocId > 0) {
      this.IsDeleteAction.emit(true);
      const dialogRef = this.Diloge.open(DialogeComponent, {
        width: '30%',
        maxHeight: '90%',
        panelClass: 'modal-matdelete',
        data: { "title": `Delete Document : ${doc.docInfo}`, "prefix": "Are you sure you want to delete?" },
        disableClose: true
      });
      dialogRef.afterClosed().subscribe((data: { event: string; }) => {
        this.IsDeleteAction.emit(false);
        if (data.event == 'Yes') {
          this.deleteItem.emit(doc);
        }
      })
    }
      else {
        this.deleteItem.emit(doc);
      }
  }
}
